import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { PrepaidCardImageRow } from '@models/prepaidCard';

import CardGrid from './CardGrid';
import ImageSwiper from './ImageSwiper';
import PpCardProvider from './providers/PpCardProvider';

interface Props {
    data: PrepaidCardImageRow;
    type: 'GIFT' | 'BUY';
    giftItemId?: string;
}

function CardList({ data, type, giftItemId }:Props) {
    const { categoryName } = data;
    return (
        <PpCardProvider type={type} data={data} giftItemId={giftItemId}>
            <Container align='center'
                fullWidth
                spacing={20}>
                <ImageSwiper/>
                <Text size='xl' fontWeight='bold' color={colors.gray7}>
                    {categoryName}
                </Text>
                <CardGrid/>
            </Container>
        </PpCardProvider>
    );
}

const Container = styled(Column)`
    padding: 0 0 46px;
`;

export default CardList;
